import type { FragmentType } from 'src/gql';
import { graphql, unmaskFragment } from 'src/gql';
import { liabilitySubtitle, liabilityTitle, renderIconForLiability } from 'src/utils/liability';

import PortfolioItemDescriptionRow from '../views/portfolio-item-description-row';

export const PortfolioLiabilityDescriptionRowFragment = graphql(/* GraphQL */ `
  fragment PortfolioLiabilityDescriptionRow on Liability {
    ...RenderIconForLiability
    name
    type
  }
`);

export default function PortfolioLiabilityDescriptionRow({
  liabilityFrag,
}: {
  readonly liabilityFrag: FragmentType<typeof PortfolioLiabilityDescriptionRowFragment>;
}) {
  const liability = unmaskFragment(PortfolioLiabilityDescriptionRowFragment, liabilityFrag);

  return (
    <PortfolioItemDescriptionRow
      icon={renderIconForLiability(liability)}
      title={liabilityTitle({ liabilityName: liability.name })}
      subtitle={liabilitySubtitle(liability.type)}
    />
  );
}
